import loadable from '@loadable/component';
export const manifest = {
  'SmeDeliveryControl.Provider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControl";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControl" */
          './components/sme-delivery-control'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/sme-delivery-control");
            }

            return eval('require.resolve')("./components/sme-delivery-control");
          }

        }, {
          resolveComponent: m => m.DeliveryControl
        })
      }
    }
  },
  'SmeDeliveryControl.MapWithFields': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlMapWithFieldsDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlMapWithFieldsDesktop" */
          './components/map-with-fields-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/map-with-fields-desktop");
            }

            return eval('require.resolve')("./components/map-with-fields-desktop");
          }

        }, {
          resolveComponent: mod => mod.MapWithFields
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlMapWithFieldsMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlMapWithFieldsMobile" */
          './components/map-with-fields-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./components/map-with-fields-mobile");
            }

            return eval('require.resolve')("./components/map-with-fields-mobile");
          }

        }, {
          resolveComponent: mod => mod.MapWithFields
        })
      }
    }
  },
  'SmeDeliveryControl.TimeslotsViewer': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlDeliveryTimeslotsViewer";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlDeliveryTimeslotsViewer" */
          './src/components/delivery-timeslots-viewer'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/delivery-timeslots-viewer");
            }

            return eval('require.resolve')("./src/components/delivery-timeslots-viewer");
          }

        }, {
          resolveComponent: mod => mod.DeliveryTimeslotsViewer
        })
      }
    }
  },
  'SmeDeliveryControl.SelectTimeslot': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlSelectTimeslot";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlSelectTimeslot" */
          './src/components/select-timeslot'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/select-timeslot");
            }

            return eval('require.resolve')("./src/components/select-timeslot");
          }

        }, {
          resolveComponent: mod => mod.SelectTimeslot
        })
      }
    }
  },
  'SmeDeliveryControl.DeliveryTimeslots': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlDeliveryTimeslotsDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlDeliveryTimeslotsDesktop" */
          './src/components/delivery-timeslots/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/delivery-timeslots/desktop");
            }

            return eval('require.resolve')("./src/components/delivery-timeslots/desktop");
          }

        }, {
          resolveComponent: mod => mod.DeliveryTimeslots
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlDeliveryTimeslotsMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlDeliveryTimeslotsMobile" */
          './src/components/delivery-timeslots/mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/delivery-timeslots/mobile");
            }

            return eval('require.resolve')("./src/components/delivery-timeslots/mobile");
          }

        }, {
          resolveComponent: mod => mod.DeliveryTimeslots
        })
      }
    }
  },
  'SmeDeliveryControl.AppointmentMeeting': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlAppointmentMeetingDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlAppointmentMeetingDesktop" */
          './src/components/appointment-meeting/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/appointment-meeting/desktop");
            }

            return eval('require.resolve')("./src/components/appointment-meeting/desktop");
          }

        }, {
          resolveComponent: mod => mod.AppointmentMeeting
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlAppointmentMeetingMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlAppointmentMeetingMobile" */
          './src/components/appointment-meeting/mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/appointment-meeting/mobile");
            }

            return eval('require.resolve')("./src/components/appointment-meeting/mobile");
          }

        }, {
          resolveComponent: mod => mod.AppointmentMeeting
        })
      }
    }
  },
  'SmeDeliveryControl.SkipDelivery': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlSkipDelivery";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlSkipDelivery" */
          './src/components/skip-delivery/skip-delivery'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/skip-delivery/skip-delivery");
            }

            return eval('require.resolve')("./src/components/skip-delivery/skip-delivery");
          }

        }, {
          resolveComponent: mod => mod.SkipDelivery
        })
      }
    }
  },
  'SmeDeliveryControl.ErrorPlate': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlErrorPlateDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlErrorPlateDesktop" */
          './src/components/delivery-timeslots/components/error-plate/mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/delivery-timeslots/components/error-plate/mobile");
            }

            return eval('require.resolve')("./src/components/delivery-timeslots/components/error-plate/mobile");
          }

        }, {
          resolveComponent: mod => mod.ErrorPlate
        })
      },
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeDeliveryControlErrorPlateMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeDeliveryControlErrorPlateMobile" */
          './src/components/delivery-timeslots/components/error-plate/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/components/delivery-timeslots/components/error-plate/desktop");
            }

            return eval('require.resolve')("./src/components/delivery-timeslots/components/error-plate/desktop");
          }

        }, {
          resolveComponent: mod => mod.ErrorPlate
        })
      }
    }
  }
};